var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 99,
    viewBox: "0 0 134 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polo Logo 2",
    clipPath: "url(#clip0_8643_181698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3697 91.323H4.54789V98.4461H0V74.241C3.78899 74.241 7.58074 74.2078 11.3697 74.2078C23.1534 74.2078 23.1893 91.3258 11.3697 91.3258V91.323ZM4.54789 87.1384H11.3697C17.1926 87.1384 17.1595 78.5614 11.3697 78.5614H4.54789V87.1384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.7214 86.4821C48.6524 92.7411 44.8275 99.0001 36.3499 99.0001C27.8723 99.0001 23.9453 92.8796 23.9453 86.5154C23.9453 80.1511 28.0103 73.7537 36.3499 73.7537C44.6895 73.7537 48.7904 80.1511 48.7214 86.4793V86.4821ZM28.427 86.5846C28.5318 90.5615 30.6678 94.8154 36.3527 94.8154C42.0375 94.8154 44.1735 90.5283 44.2425 86.5513C44.3115 82.4719 42.0375 77.9079 36.3527 77.9079C30.6678 77.9079 28.3249 82.5079 28.427 86.5874V86.5846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.3331 74.2383V94.2255H70.7376V98.4434H53.7852V74.2383H58.3331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M98.6491 86.4821C98.5801 92.7411 94.7553 99.0001 86.2776 99.0001C77.8 99.0001 73.873 92.8796 73.873 86.5154C73.873 80.1511 77.938 73.7537 86.2776 73.7537C94.6173 73.7537 98.7181 80.1511 98.6491 86.4793V86.4821ZM78.3547 86.5846C78.4596 90.5615 80.5955 94.8154 86.2804 94.8154C91.9653 94.8154 94.1012 90.5283 94.1702 86.5513C94.2392 82.4719 91.9653 77.9079 86.2804 77.9079C80.5955 77.9079 78.2526 82.5079 78.3547 86.5874V86.5846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M128.761 74.2383H133.759V74.446L125.593 86.2024L134.002 98.3049V98.4434H128.902L122.734 89.3485L116.567 98.4434H111.467V98.3049L119.84 86.2024L111.707 74.446V74.2383H116.705L122.734 83.264L128.764 74.2383H128.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M84.505 0H101.894L40.0996 55.4917L84.505 0Z",
    fill: "#FDC517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M69.0566 35.4047L85.6504 55.6274H101.861L78.4035 27.0105L69.0566 35.4047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M67.6478 14.0217L56.3581 0.00268555L40.1562 0.00822447L59.6311 24.0416L67.6478 14.0217Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8643_181698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49d5c77248078b457d0c575a07424bd5.svg";
export { ForwardRef as ReactComponent };